export default __webpack_public_path__ + "static/O0034-a4a95080d47d6f2a0b4fcb9861a23e0c.png";